"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "FormHeroRadioSelect", {
    enumerable: true,
    get: function() {
        return FormHeroRadioSelect;
    }
});
const _style = /*#__PURE__*/ _interop_require_default(require("styled-jsx/style"));
const _react = /*#__PURE__*/ _interop_require_wildcard(require("react"));
const _Theme = require("../../../contexts/Theme");
const _Text = require("../../Text/Text");
const _FormGroupContext = require("../../../contexts/FormGroupContext");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
const FormHeroRadioSelect = (param)=>{
    let { field: { name, value, onChange }, icon: Icon, title, className, description, id, ...props } = param;
    const { hintId, hasError } = (0, _react.useContext)(_FormGroupContext.FormGroupContext);
    const { colors } = (0, _Theme.useTheme)();
    const checked = (0, _react.useMemo)(()=>{
        var _props_default;
        return value == null ? (_props_default = props.default) !== null && _props_default !== void 0 ? _props_default : id === value : id === value;
    }, [
        id,
        value,
        props.default
    ]);
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement("label", {
        htmlFor: id,
        className: _style.default.dynamic([
            [
                "f3e747d94d70193f",
                [
                    colors.grayscale[20],
                    colors.blue[60],
                    colors.blue[60],
                    colors.transparent.black[10],
                    colors.transparent.black[5],
                    colors.status.danger.primary,
                    colors.blue[10],
                    colors.blue[60],
                    colors.transparent.black[60]
                ]
            ]
        ]) + " " + ("label ".concat(checked ? "label--active" : "", " ").concat(hasError ? "label--error" : "", " ").concat(className !== null && className !== void 0 ? className : "").trim() || "")
    }, /*#__PURE__*/ _react.default.createElement("div", {
        className: _style.default.dynamic([
            [
                "f3e747d94d70193f",
                [
                    colors.grayscale[20],
                    colors.blue[60],
                    colors.blue[60],
                    colors.transparent.black[10],
                    colors.transparent.black[5],
                    colors.status.danger.primary,
                    colors.blue[10],
                    colors.blue[60],
                    colors.transparent.black[60]
                ]
            ]
        ]) + " " + "control"
    }, /*#__PURE__*/ _react.default.createElement(Icon, {
        size: 24,
        fill: checked ? colors.blue[60] : "#000",
        className: _style.default.dynamic([
            [
                "f3e747d94d70193f",
                [
                    colors.grayscale[20],
                    colors.blue[60],
                    colors.blue[60],
                    colors.transparent.black[10],
                    colors.transparent.black[5],
                    colors.status.danger.primary,
                    colors.blue[10],
                    colors.blue[60],
                    colors.transparent.black[60]
                ]
            ]
        ])
    }), /*#__PURE__*/ _react.default.createElement("input", {
        name: name,
        id: id,
        value: id,
        checked: checked,
        "aria-describedby": hintId,
        onChange: onChange,
        ...props,
        type: "radio",
        className: _style.default.dynamic([
            [
                "f3e747d94d70193f",
                [
                    colors.grayscale[20],
                    colors.blue[60],
                    colors.blue[60],
                    colors.transparent.black[10],
                    colors.transparent.black[5],
                    colors.status.danger.primary,
                    colors.blue[10],
                    colors.blue[60],
                    colors.transparent.black[60]
                ]
            ]
        ]) + " " + (props && props.className != null && props.className || "")
    })), /*#__PURE__*/ _react.default.createElement("div", {
        className: _style.default.dynamic([
            [
                "f3e747d94d70193f",
                [
                    colors.grayscale[20],
                    colors.blue[60],
                    colors.blue[60],
                    colors.transparent.black[10],
                    colors.transparent.black[5],
                    colors.status.danger.primary,
                    colors.blue[10],
                    colors.blue[60],
                    colors.transparent.black[60]
                ]
            ]
        ]) + " " + "info"
    }, /*#__PURE__*/ _react.default.createElement(_Text.Text, {
        variant: "heading",
        size: "small",
        className: "mb-2"
    }, title), /*#__PURE__*/ _react.default.createElement(_Text.Text, {
        variant: "text",
        size: "extra-small",
        className: "description m-0"
    }, description))), /*#__PURE__*/ _react.default.createElement(_style.default, {
        id: "f3e747d94d70193f",
        dynamic: [
            colors.grayscale[20],
            colors.blue[60],
            colors.blue[60],
            colors.transparent.black[10],
            colors.transparent.black[5],
            colors.status.danger.primary,
            colors.blue[10],
            colors.blue[60],
            colors.transparent.black[60]
        ]
    }, 'input[type="radio"].__jsx-style-dynamic-selector{width:24px;height:24px;background:#fff;border:1px solid '.concat(colors.grayscale[20], ';-webkit-border-radius:50%;-moz-border-radius:50%;border-radius:50%;-webkit-appearance:none;-moz-appearance:none;-ms-appearance:none;appearance:none;position:relative;margin:0}input[type="radio"].__jsx-style-dynamic-selector:checked{border-color:').concat(colors.blue[60], '}input[type="radio"].__jsx-style-dynamic-selector:checked:before{content:"";position:absolute;-webkit-transform:translate(50%,50%);-moz-transform:translate(50%,50%);-ms-transform:translate(50%,50%);-o-transform:translate(50%,50%);transform:translate(50%,50%);top:0;left:0;width:50%;height:50%;-webkit-border-radius:50%;-moz-border-radius:50%;border-radius:50%;background-color:').concat(colors.blue[60], "}.label.__jsx-style-dynamic-selector{display:-webkit-inline-box;display:-webkit-inline-flex;display:-moz-inline-box;display:-ms-inline-flexbox;display:inline-flex;white-space:nowrap;max-width:100%;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-border-radius:4px;-moz-border-radius:4px;border-radius:4px;padding:1rem;border:1px solid ").concat(colors.transparent.black[10], "}.label.__jsx-style-dynamic-selector:not(.label--active):hover{background-color:").concat(colors.transparent.black[5], "}.label--error.__jsx-style-dynamic-selector,.label-error.__jsx-style-dynamic-selector input.__jsx-style-dynamic-selector{border-color:").concat(colors.status.danger.primary, "}.label--active.__jsx-style-dynamic-selector{background-color:").concat(colors.blue[10], ";border-color:").concat(colors.blue[60], "}.control.__jsx-style-dynamic-selector{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-webkit-justify-content:space-between;-moz-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;margin-bottom:.5rem}.info.__jsx-style-dynamic-selector{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;overflow:hidden;white-space:normal}.info.__jsx-style-dynamic-selector .description{color:").concat(colors.transparent.black[60], "}")));
};

//# sourceMappingURL=FormHeroRadioSelect.js.map